<div class="mb-3 vertical-form" *ngIf="!field.hide && !to.hidden">
    <label
        [attr.for]="key"
        class="form-control-label {{
            to && to.labelClass ? to.labelClass : ''
        }}"
    >
        {{ to.label }}{{ to.required ? "*" : "" }}
        <span class="tt" *ngIf="to.title">
            <fa-icon class="ms-2" [icon]="faInfoSign"></fa-icon>
            <span class="tttext">{{ to.title }}</span>
        </span>
    </label>
    <div *ngIf="to && to.topNote" class="field-notes">
        <sub [innerHTML]="to.topNote"></sub>
    </div>
    <div
        [hidden]="to.isUrl"
        class="{{ to && to.entityClass ? to.entityClass : '' }}"
        [class.field-has-error]="showError"
    >
        <ng-template #fieldComponent autocomplete="nope"></ng-template>
    </div>
    <div
        *ngIf="to.isUrl"
        class="{{ to && to.entityClass ? to.entityClass : '' }}"
    >
        <a class="btn-link" [href]="formControl.value" target="_blank">{{
            formControl.value
        }}</a>
    </div>
    <div *ngIf="to && to.note" class="field-notes">
        <sub [innerHTML]="to.note"></sub>
    </div>
</div>
